import React from "react";
import { Box, Typography, Stack, Button, Divider } from "@mui/material";
// import { ReactComponent as BloodInsight } from "../assets/BloodInsight.svg";
import { ReactComponent as BloodInsight } from "../assets/ph.svg";
import { ReactComponent as Vpk } from "../assets/vpk1.svg";
import { ReactComponent as Eira } from "../assets/eira.svg";
import { ReactComponent as Check } from "../assets/check.svg";
import { scrollToElement } from "../helper";

const products = [
  {
    icon: BloodInsight,
    header: "Blood Insight Pro",
    subheader: "Data Driven Intelligence",
    descriptionList: [
      "Analyzing blood reports for actionable insights.",
      "Predict and prevent metabolic diseases.",
      "Analyzing biomarkers to predict Anemia, Thyroid issues, Type 2 Diabetes, Hypertension, and CVD.",
      "Personalised recommendations.",
    ],
    btnTextLink: "#form1",
  },
  {
    icon: Vpk,
    header: "VPK",
    subheader: "Dosha Analyzer",
    descriptionList: [
      "Non-invasive device based on ancient diagnostic technique of Nadi Pariksha (Pulse Detection)",
      "Real-time data collection of Dosha imbalances: Vata, Pitta, and Kapha.",
      "Designed to assess health status and aid in disease diagnosis.",
    ],
    btnTextLink: "#form1",
  },
  {
    icon: Eira,
    header: "EIRA",
    subheader: "AI That Cares For You",
    descriptionList: [
      "EIRA uses DxAi's proprietary AAA algorithm to predict health risks.",
      "Provides personalized strategies for proactive health management.",
      "Enables continuous health tracking with real-time updates.",
      "Integrates advanced diagnostics and care with digital insights.",
      "Access expert consultations online and offline for personalized guidance.",
    ],
    btnTextLink: "#form1",
  },
];

export default function OurProducts() {
  return (
    <Box
      sx={{
        px: { xs: 2, md: 6 },
        py: 6,
        width: "80%",
        margin: "auto",
        borderColor: "rgba(177, 181, 195, 1)",
        borderStyle: "solid",
        borderWidth: "2px",
        borderRadius: { xs: "20px", sm: "40px" },
        mb: 10,
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
      id="products"
    >
      <Typography
        fontWeight={"700"}
        fontSize={{
          xs: "24px",
          sm: "32px",
          lg: "48px",
        }}
        sx={{ mb: 6 }}
        fontFamily={"SF Pro Display"}
      >
        <span style={{ color: "#2361df", fontFamily: "SF Pro Display" }}>
          O
        </span>
        ur{" "}
        <span style={{ color: "#2361df", fontFamily: "SF Pro Display" }}>
          P
        </span>
        roducts
      </Typography>

      <Stack spacing={6}>
        {products.map((product, index) => (
          <Stack
            key={index}
            spacing={4}
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <ProductCard
              key={index}
              icon={product.icon}
              header={product.header}
              subheader={product.subheader}
              descriptionList={product.descriptionList}
              btnTextLink={product.btnTextLink}
              direction={{
                xs: "column",
                md: index % 2 === 0 ? "row" : "row-reverse", // Alternating layouts for large screens
              }}
            />
            {index !== products.length - 1 && (
              <Divider
                sx={{
                  width: "80%",
                }}
              />
            )}
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}

const ProductCard = ({
  icon: Icon,
  direction,
  header,
  subheader,
  descriptionList,
  btnTextLink,
}) => {
  return (
    <Stack direction="column" spacing={3} alignItems="center">
      {/* Centered Headers */}
      <Stack direction={"column"} spacing={1} alignItems="center">
        <Typography
          fontWeight={700}
          fontSize={{
            lg: "36px",
            md: "32px",
            sm: "24px",
          }}
          fontFamily={"SF Pro Display"}
        >
          {header}
        </Typography>
        <Typography
          fontWeight={600}
          fontSize={{
            lg: "24px",
            md: "20px",
            sm: "16px",
          }}
          color="rgba(106, 106, 106, 1)"
          fontFamily={"SF Pro Display"}
        >
          {subheader}
        </Typography>
      </Stack>

      <Stack
        direction={direction}
        spacing={4}
        alignItems="center"
        sx={{
          width: "100%",
          maxWidth: "1100px",
          mx: "auto",
        }}
      >
        {/* Image Section */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: { xs: "200px", md: "400px" }, // Keeps images aligned
          }}
        >
          <Icon style={{ width: "100%", maxWidth: "450px" }} />
        </Box>

        {/* Content Section */}
        <Stack
          flex={1}
          spacing={2}
          alignItems="flex-start" // Ensures child items align to the left
        >
          {descriptionList.map((desc, i) => (
            <Box>
              <Stack key={i} direction="row" spacing={1} alignItems="center">
                <Box
                  sx={{
                    height: { md: "8px", lg: "10px" }, // Fixed height
                    width: { md: "12px", lg: "14px" }, // Fixed width
                    flexShrink: 0, // Prevent shrinking
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Check
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover", // Ensures the SVG fills the entire box
                    }}
                    preserveAspectRatio="none" // This removes aspect ratio constraints, making it stretch to fit
                  />
                </Box>
                <Typography
                  color="rgba(106, 106, 106, 1)"
                  fontWeight={500}
                  fontSize={{
                    lg: "20px",
                    md: "16px",
                    sm: "14px",
                    xs: "12px",
                  }}
                  fontFamily={"SF Pro Display"}
                >
                  {desc}
                </Typography>
              </Stack>
            </Box>
          ))}

          {/* Request Demo Button */}
          <Button
            variant="outlined"
            sx={{
              color: "rgba(35, 97, 223, 1)",
              mt: 2,
              width: "content-fit",
              backgroundColor: "transparent",
            }}
            style={{
              marginLeft: "25px",
              padding: "8px 15px",
            }}
            onClick={() => {
              const element = document.getElementById("about-us");
              if (element) {
                scrollToElement("about-us");
              }
            }}
          >
            <Typography
              sx={{
                color: "rgba(35, 97, 223, 1)",
                fontSize: {
                  lg: "16px",
                  md: "14px",
                  sm: "12px",
                  xs: "10px",
                },
                fontFamily: "SF Pro Display",
                fontWeight: 700,
              }}
            >
              Request a demo
            </Typography>
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
